import ServiceCategoryPage from "../components/ServiceCategoryPage";
import tvRepairService from "../data/services/tvRepairService";

function TVRepair() {
  return <ServiceCategoryPage service={tvRepairService} />;
}

export default TVRepair;